<template>
  <div>
    <v-container>
      <v-layout column justify-center align-center>
        <v-flex md4 xs12 sm6 class="text-center mb-2" v-if="uiSettings.logo">
          <a v-bind:href="uiSettings.contacts.site" target="_blank">
            <img :src="uiSettings.logo" class="logo">
          </a>
          <p v-if="uiSettings.contacts.name">
            {{ uiSettings.contacts.name }}
          </p>
        </v-flex>
        <v-card v-if="!isLoadingUserData && user" width="500">
          <form @submit.prevent="createPayment">
            <v-card-text class="black--text show-scrollbar pt-4 pb-2 pb-sm-4">
              <v-progress-linear
                :active="loading"
                :indeterminate="loading"
                absolute
                bottom
                color="primary"
              ></v-progress-linear>

              <v-radio-group
                @change="changePayFor"
                hide-details
                class="mt-0"
                v-model="payFor">
                <v-radio
                  v-if="selectInvoices.length
                    && (!preassignedPayload.payFor || preassignedPayload.payFor === 'invoice')"
                  :label="'Оплатить счет'"
                  :value="'invoice'"
                ></v-radio>
                <v-radio
                  v-if="selectJoins.length
                    && (!preassignedPayload.payFor || preassignedPayload.payFor === 'join')"
                  :label="'Купить абонемент/оплатить обучение'"
                  :value="'join'"
                ></v-radio>
                <v-radio
                  v-if="uiSettings.onlinePayment.depositOnBalans
                    && (!preassignedPayload.payFor || preassignedPayload.payFor === 'balans')"
                  :label="'Внести сумму на баланс'"
                  :value="'balans'"
                ></v-radio>
              </v-radio-group>

              <div class="pt-5" v-if="payFor==='invoice' && selectInvoices.length">
<!--                <h2-->
<!--                  v-if="currentDebt === totalDebt && !preassignedPayload.invoiceId"-->
<!--                  class="body-1"-->
<!--                >-->
<!--                  Сумма: <span class="red&#45;&#45;text">{{ totalDebt }} </span>-->
<!--                  {{ currency }}-->
<!--                </h2>-->
<!--                <h2 v-else-if="!preassignedPayload.invoiceId" class="body-1">-->
<!--                  Сумма:-->
<!--                  <span class="red&#45;&#45;text">{{ currentDebt }}</span>-->
<!--                  из-->
<!--                  <span class="red&#45;&#45;text">{{ totalDebt }}</span>-->
<!--                  {{ currency }}-->
<!--                </h2>-->
<!--                <h2 v-else class="body-1">-->
<!--                  Счет для оплаты-->
<!--                </h2>-->

                <h2 class="body-1">Выберите счет</h2>

                <v-radio-group
                  @change="invoiceChange"
                  required
                  v-model="payload.invoiceId"
                  hide-details
                >
                  <v-radio
                    v-for="invoice in selectInvoices"
                    :key="invoice.id"
                    :value="invoice.id"
                  >
                    <template slot="label">
                      <div class="d-block">
                        <div>{{ invoice.displayName }}</div>
                        <div class="caption grey--text">
                          <span :class="invoice.payUntilClass">
                            Оплатить до {{ invoice.payUntil }}
                          </span>
                          Счет №{{ invoice.id }}
                        </div>
                      </div>
                    </template>
                  </v-radio>
                </v-radio-group>

                <div v-if="showBonuses" class="grey lighten-3 pt-3 pl-2 mb-5 pb-3 mt-5">
                  <h2 class="body-1">
                    Бонусы:
                    <span class="primary--text">
                      {{ user.bonusBalance }}
                    </span>
                  </h2>
                  <span class="caption grey--text">
                    Можно списать: {{ payload.availableBonuses }}
                  </span>

                  <div class="mc-bonuses-block">
                    <v-checkbox
                      v-if="user.bonusBalance"
                      v-model="payload.debitBonuses"
                      :label="'Списать бонусы'"
                      hide-details>
                    </v-checkbox>

                    <v-text-field
                      v-if="payload.debitBonuses"
                      v-model="payload.bonusesSumma"
                      class="mb-2 mc-bonuses-sum"
                      :label="'Сумма'"
                      :placeholder="String(payload.availableBonuses)"
                      type="number"
                      max="payload.availableBonuses"
                      step="0.01"
                      min="0">
                    </v-text-field>
                  </div>

                </div>

                <div class="grey lighten-3 pt-3 pl-2 mt-5 mb-5 pb-3">
                  <h2 class="body-1">
                    Баланс:
                    <span class="primary--text">{{ user.availableBalance }}</span>
                    {{ currency }}
                  </h2>

                  <v-checkbox
                    v-if="user.availableBalance"
                    v-model="payload.debitFromBalans"
                    :label="'Списать средства с баланса'"
                    hide-details>
                  </v-checkbox>
                </div>

                <h2 class="body-1">
                  Итого к оплате:
                  <span class="primary--text">{{ totalSum }}</span>
                  {{ currency }}
                </h2>
              </div>

              <div class="pt-5" v-if="payFor==='join' && selectJoins.length">
                <h2 class="body-1">
                  Ваши направления/группы
                </h2>

                <v-radio-group
                  @change="joinChange"
                  required
                  v-model="payload.joinId"
                >
                  <v-radio
                    v-for="join in selectJoins"
                    :key="join.id"
                    :label="join.displayName"
                    :value="join.id"
                  ></v-radio>
                </v-radio-group>

                <h2 v-if="selectSubscriptionTypes.length" class="body-1">
                  Выберите абонемент
                </h2>

                <v-select
                  v-if="selectSubscriptionTypes.length"
                  :items="selectSubscriptionTypes"
                  v-model="payload.subscriptionId"
                  item-text="displayName"
                  item-value="id"
                  label="Абонемент"
                  @change="subsChange"
                >
                  <template v-slot:selection="{ item }">
                    <div class="line-item" style="display: inline">
                      {{ item.displayName }} <v-icon v-if="item.family" size="19">
                        mdi-account-multiple
                      </v-icon>
                    </div>
                  </template>
                  <template v-slot:item="{ item }">
                    <div class="line-item" style="display: inline">
                      {{ item.displayName }} <v-icon v-if="item.family" size="19">
                        mdi-account-multiple
                      </v-icon>
                    </div>
                  </template>
                </v-select>

                <h2 v-if="isShowSubscriptionBeginDateSelect" class="body-1">
                  Начало действия абонемента
                </h2>

                <v-radio-group
                  v-if="isShowSubscriptionBeginDateSelect"
                  required v-model="payload.subscriptionStartDate">
                  <v-radio
                    v-if="!preassignedPayload.subscriptionStartDate
                || preassignedPayload.subscriptionStartDate === 'fromNextMonth'"
                    :label="'Со следующего месяца'"
                    :value="'fromNextMonth'"
                  ></v-radio>
                  <v-radio
                    v-if="!preassignedPayload.subscriptionStartDate
                || preassignedPayload.subscriptionStartDate === 'fromThisMonth'"
                    :label="'С начала текущего месяца'"
                    :value="'fromThisMonth'"
                  ></v-radio>
                  <v-radio
                    v-if="!preassignedPayload.subscriptionStartDate
                || preassignedPayload.subscriptionStartDate === 'fromNow'"
                    :label="'С текущей даты'"
                    :value="'fromNow'"
                  ></v-radio>
                </v-radio-group>

                <h2 class="body-1 mb-5" v-if="joinDiscount">
                  Скидка:
                  <span class="primary--text">{{ joinDiscount }}</span>
                  {{ currency }}
                </h2>

                <v-alert
                  outlined
                  type="warning"
                  v-if="maxDiscount && userDiscount >= maxDiscount"
                  class="body-2"
                >
                  Максимальная скидка ограничена настройками абонемента/группы в {{ maxDiscount }}%.
                </v-alert>

                <v-text-field
                  v-if="isShowPriceInput && subPriceLimits.max
                    && subPriceLimits.min && !preassignedPayload.summa"
                  v-model="payload.summa"
                  class="mb-2"
                  :label="`Сумма оплаты
                  (от ${subPriceLimits.min} до ${subPriceLimits.max} ${currency})`"
                  :placeholder="String(subPriceLimits.max)"
                  type="number"
                  @change="changePaySum"
                  min="1">
                </v-text-field>

                <div v-if="showBonuses" class="grey lighten-3 pt-3 pl-2 mb-5 pb-3">
                  <h2 class="body-1">
                    Бонусы:
                    <span class="primary--text">
                      {{ user.bonusBalance }}
                    </span>
                  </h2>
                  <span
                    class="caption grey--text">
                    Можно списать: {{ payload.availableBonuses }}
                  </span>

                  <div class="mc-bonuses-block">
                    <v-checkbox
                      v-if="user.bonusBalance"
                      v-model="payload.debitBonuses"
                      :label="'Списать бонусы'"
                      hide-details>
                    </v-checkbox>

                    <v-text-field
                      v-if="payload.debitBonuses"
                      v-model="payload.bonusesSumma"
                      class="mb-2 mc-bonuses-sum"
                      :label="'Сумма'"
                      :placeholder="String(payload.availableBonuses)"
                      type="number"
                      max="payload.availableBonuses"
                      step="0.01"
                      min="0">
                    </v-text-field>
                  </div>

                </div>

                <div class="grey lighten-3 pt-3 pl-2 mb-5 pb-3">
                  <h2 class="body-1">
                    Баланс:
                    <span class="primary--text">{{ user.availableBalance }}</span>
                    {{ currency }}
                  </h2>

                  <v-checkbox
                    v-if="user.availableBalance"
                    v-model="payload.debitFromBalans"
                    :label="'Списать средства с баланса'"
                    hide-details>
                  </v-checkbox>
                </div>

                <h2 class="body-1">
                  Итого к оплате:
                  <span class="primary--text">{{ totalSum }}</span>
                  {{ currency }}
                </h2>
              </div>

              <div
                class="pt-3"
                v-bind:class="{'pb-2': onlinePaymentIntegrationsSelect
                  && onlinePaymentIntegrationsSelect.length > 1 }"
                v-if="payFor==='balans' && uiSettings.onlinePayment.depositOnBalans"
              >
                <v-text-field
                  v-model="payload.summa"
                  label="Сумма"
                  type="number"
                  hide-details
                  min="1">
                </v-text-field>
              </div>

              <v-select
                class="mt-4"
                v-if="onlinePaymentIntegrationsSelect && onlinePaymentIntegrationsSelect.length > 1"
                :items="onlinePaymentIntegrationsSelect"
                v-model="integrationId"
                item-text="name"
                item-value="id"
                hide-details
                label="Платежная система"
              ></v-select>

              <div
                class="agreements pt-6"
                v-if="onlinePaymentSettings.dataProcessingAgreement.enabled
                  || onlinePaymentSettings.userLicenseAgreement.enabled"
              >
                <v-checkbox
                  class="mt-2"
                  v-model="agreements.dataProcessingAgreement"
                  hide-details="true"
                  v-if="onlinePaymentSettings.dataProcessingAgreement.enabled
                    && onlinePaymentSettings.dataProcessingAgreement.link"
                >
                  <template v-slot:label>
                    <div class="description">
                      {{
                        onlinePaymentSettings.dataProcessingAgreement.description
                        || 'Я согласен с политикой обработки персональных данных.'
                      }}
                      <a
                        :href="onlinePaymentSettings.dataProcessingAgreement.link"
                        target="_blank"
                        @click.stop
                      >Подробнее</a>
                    </div>
                  </template>
                </v-checkbox>

                <v-checkbox
                  class="mt-2"
                  v-model="agreements.userLicenseAgreement"
                  hide-details="true"
                  v-if="onlinePaymentSettings.userLicenseAgreement.enabled
                      && onlinePaymentSettings.userLicenseAgreement.link"
                >
                  <template v-slot:label>
                    <div class="description">
                      {{
                        onlinePaymentSettings.userLicenseAgreement.description
                        || 'Я согласен с условиями пользовательского соглашения.'
                      }}
                      <a
                        :href="onlinePaymentSettings.userLicenseAgreement.link"
                        target="_blank"
                        @click.stop
                      >Подробнее</a>
                    </div>
                  </template>
                </v-checkbox>
              </div>

              <v-alert
                outlined
                type="warning"
                class="body-2 mt-4 mb-0"
                v-if="onlinePaymentIntegrationsSelect && !onlinePaymentIntegrationsSelect.length"
              >
                Нет подходящей платежной системы. Пожалуйста, обратитесь в вашу школу.
              </v-alert>
            </v-card-text>
            <v-card-actions class="align-center align-center justify-center flex-wrap">
              <v-btn
                type="submit"
                :disabled="!formValid || loading"
                text
                :key="refreshKey"
                color="accent"
              >
                {{ createPaymentBtnText }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
        <v-card v-if="isLoadingUserData" width="500">
          <v-skeleton-loader
            type="
              card-heading,
              list-item-two-line,
              card-heading,
              list-item-three-line,
              list-item-three-line,
              actions"
          ></v-skeleton-loader>
        </v-card>
        <div class="mt-6 contacts text-center">
          <div class="caption" v-if="uiSettings.contacts.phone">
            {{ uiSettings.contacts.phone }}
          </div>
          <div class="caption" v-if="uiSettings.contacts.email">
            <a v-bind:href="'mailto:'+uiSettings.contacts.email">
              {{ uiSettings.contacts.email }}</a>
          </div>
          <div class="caption" v-if="companySite">
            <a v-bind:href="uiSettings.contacts.site" target="_blank">{{ companySite }}</a>
          </div>
        </div>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment-timezone';
import { mapGetters, mapMutations } from 'vuex';

import UserData from '@/api/UserData';
import Payment from '@/api/Payment';
import { getDisplayName, getSubscriptionForPayment } from '@/lib/subscriptionHelpers';
import initPaymentProcess from '@/lib/paymentHelper';
import {
  calculateDiscount,
  getAvailableBonusesSum,
  isValidEntityForBPLevel,
} from '@/lib/bonusProgramHelper';

export default {
  name: 'CreatePayment',
  components: {},
  data: () => {
    const payFor = 'invoice';
    const payload = {};

    return {
      payFor,
      payload,
      joins: [],
      classes: [],
      invoices: [],
      userSubscriptions: [],
      subscriptionTypes: [],
      preassignedPayload: {},
      onlinePaymentIntegrations: [],
      onlinePaymentSettings: {},
      totalDebt: 0,
      currentDebt: 0,
      refreshKey: 0,
      payLinkKey: null,
      uiSettings: { onlinePayment: {}, contacts: {} },
      loading: false,
      integrationId: null,
      isLoadingUserData: false,
      agreements: {
        dataProcessingAgreement: false,
        userLicenseAgreement: false,
      },
      showBonuses: false,
    };
  },
  computed: {
    companySite() {
      if (this.uiSettings.contacts.site) {
        const matches = this.uiSettings.contacts.site.match(/^https?:\/\/([^/?#]+)(?:[/?#]|$)/i);
        return matches && matches[1];
      }
      return false;
    },
    bpLevel() {
      if (!this.user) {
        return null;
      }

      const { bpLevel } = this.user;

      if (!bpLevel || !bpLevel.isActive) {
        return null;
      }

      return {
        id: bpLevel.id,
        params: bpLevel.levelParams,
      };
    },
    userDiscount() {
      return this.userDiscounts.discount;
    },
    maxDiscount() {
      return this.userDiscounts.maxDiscount;
    },
    userDiscounts() {
      if (!this.payload.joinId) {
        return { discount: 0 };
      }

      let entity;
      let entityType;

      const discountAttr = this.user.attributes.find((attr) => attr.attributeAlias === 'discount');
      const initDiscount = discountAttr ? (+discountAttr.value || 0) : 0;

      const join = this.joins.find((el) => el.id === this.payload.joinId);
      const cl = this.classes.find((el) => el.id === join.classId);

      if (cl.payType === 'full') {
        entity = cl;
        entityType = 'class';
      } else if (!this.payload.subscriptionId) {
        return { discount: 0 };
      } else if (this.payload.subscriptionId) {
        const subType = this.subscriptionTypes
          .find((s) => s.id === this.payload.subscriptionId);

        entity = subType;
        entityType = 'sub';
      }

      const { discount, maxDiscount } = calculateDiscount({
        entityType,
        entity,
        initDiscount,
        level: this.bpLevel,
      });

      return { discount, maxDiscount };
    },
    priceForJoin() {
      if (!this.payload.joinId) {
        return 0;
      }

      const join = this.joins.find((j) => j.id === this.payload.joinId);
      if (!join) {
        return 0;
      }

      const cl = this.classes.find((c) => c.id === join.classId);

      if (cl.payType === 'full') {
        return join.price;
      }

      if (this.payload.subscriptionId) {
        const subType = this.subscriptionTypes
          .find((s) => s.id === this.payload.subscriptionId);
        const allowedSubscriptionTypeIds = this.getSubscriptionTypesForClass(cl.id)
          .map((s) => s.id);

        if (!allowedSubscriptionTypeIds.includes(subType.id)) return 0;

        const filial = this.filials.find((el) => el.id === cl.filialId);
        const updatedSub = getSubscriptionForPayment(subType, filial);
        return updatedSub.price;
      }

      return 0;
    },
    joinDiscount() {
      if (!this.payload.joinId) {
        return 0;
      }

      const join = this.joins.find((j) => j.id === this.payload.joinId);
      if (!join) {
        return 0;
      }

      const cl = this.classes.find((c) => c.id === join.classId);

      if (cl.payType === 'full') {
        return undefined;
      }

      if (this.payload.subscriptionId && cl.useDiscount && this.userDiscount) {
        return ((this.priceForJoin * (this.userDiscount)) / 100).toFixed(2);
      }

      return 0;
    },
    subPriceLimits() {
      if (!this.payload.subscriptionId || !this.payload.joinId) {
        return {};
      }

      const join = this.joins.find((j) => j.id === this.payload.joinId);
      if (!join) {
        return {};
      }

      const cl = this.classes.find((c) => c.id === join.classId);
      if (!cl || cl.payType === 'full') {
        return {};
      }

      const subType = this.getSubscriptionTypesForClass(cl.id)
        .find(({ id }) => id === this.payload.subscriptionId);

      if (!subType) {
        return {};
      }

      const result = {
        max: this.priceForJoin - this.joinDiscount,
      };

      const { partialPaymentForNewJoinMin, partialPaymentForNewJoin } = cl.onlinePayment;

      if (partialPaymentForNewJoin) {
        result.min = Math.round((result.max * +partialPaymentForNewJoinMin) / 100);
      } else {
        result.min = result.max;
      }

      return result;
    },
    isShowPriceInput() {
      if (!this.payload.subscriptionId || !this.payload.joinId) {
        return false;
      }

      const join = this.joins.find((j) => j.id === this.payload.joinId);
      if (!join) {
        return false;
      }

      const cl = this.classes.find((c) => c.id === join.classId);
      if (!cl || cl.payType === 'full') {
        return false;
      }

      return cl.onlinePayment.partialPaymentForNewJoin;
    },
    selectInvoices() {
      if (!this.invoices) {
        return [];
      }

      const invoices = this.invoices
        .map((invoice) => {
          invoice.needToPay = invoice.nextSum || invoice.price - invoice.payed;

          if (invoice.nextSum && invoice.nextSum !== invoice.price - invoice.payed) {
            invoice.displayName = `${invoice.needToPay} из ${invoice.price - invoice.payed} ${this.currency}`;
          } else {
            invoice.displayName = `${invoice.needToPay} ${this.currency}`;
          }

          if (invoice.userSubscriptionId) {
            const sub = this.userSubscriptions.find((us) => us.id === invoice.userSubscriptionId);
            if (sub) {
              invoice.displayName += ` - Аб. №${sub.id} ${this.getClassName(sub.mainClassId)}`;
            }
          }
          if (invoice.joinId) {
            const join = this.joins.find((j) => j.id === invoice.joinId);
            if (join) {
              invoice.displayName += ` - ${this.getClassName(join.classId)}`;
            }
          }

          if (invoice.payUntil) {
            const diff = -moment().diff(invoice.payUntil, 'day');
            invoice.payUntilClass = null;
            if (diff < 0) {
              invoice.payUntilClass = 'red--text';
            }
            invoice.payUntil = moment(invoice.payUntil).format('DD/MM/YYYY');
          }

          return invoice;
        })
        .filter(Boolean);

      if (this.preassignedPayload.invoiceId) {
        const invoice = invoices.find((i) => +this.preassignedPayload.invoiceId === i.id);
        if (invoice) {
          return [invoice];
        }
      }

      return invoices;
    },
    selectJoins() {
      if (!this.joins) {
        return [];
      }
      const joins = this.joins
        .map((join) => {
          const cl = this.classes.find((c) => c.id === join.classId);

          if (!cl || !cl.onlinePayment.enabledFromPayLink || cl.status === 'archive') {
            return null;
          }

          if (join.invoices.length) {
            return null;
          }

          if (join.status === 'over') {
            return null;
          }

          join.displayName = cl.name;

          if (cl.payType === 'full') {
            join.displayName += ` - ${join.price} ${this.currency}`;
          } else {
            const subscriptionTypes = this.getSubscriptionTypesForClass(cl.id);

            if (!subscriptionTypes.length) {
              return null;
            }
          }

          return join;
        })
        .filter(Boolean)
        .sort((a, b) => (a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1));

      if (this.preassignedPayload.joinId) {
        const join = joins.find((j) => +this.preassignedPayload.joinId === j.id);
        if (join) {
          return [join];
        }
      }

      return joins;
    },
    selectSubscriptionTypes() {
      if (!this.payload.joinId) {
        return [];
      }

      const join = this.joins.find((j) => j.id === this.payload.joinId);
      if (!join) {
        return [];
      }

      const subTypes = this.getSubscriptionTypesForClass(join.classId);

      if (this.preassignedPayload.subscriptionId) {
        const sub = subTypes.find((s) => +this.preassignedPayload.subscriptionId === s.id);
        if (sub) {
          return [sub];
        }
      }

      return subTypes;
    },
    isShowSubscriptionBeginDateSelect() {
      if (!this.payload.joinId || !this.payload.subscriptionId) {
        return false;
      }

      const subscriptionType = this.subscriptionTypes
        .find((s) => s.id === this.payload.subscriptionId);

      return subscriptionType ? subscriptionType.onlinePayment.beginDateSelectEnabled : false;
    },
    totalSum() {
      return this.totalSumTemp.toFixed(2);
    },
    totalSumTemp() {
      const {
        bonusesSumma,
        debitBonuses,
      } = this.payload;

      const bonuses = debitBonuses ? +bonusesSumma || 0 : 0;

      if (this.payFor === 'invoice' && this.payload.invoiceId) {
        const invoice = this.invoices.find((i) => i.id === this.payload.invoiceId);

        let { needToPay } = invoice;
        needToPay -= bonuses;

        if (this.partialPaymentForInvoice && this.payload.summa) {
          needToPay = this.payload.summa;
        }

        if (!this.payload.debitFromBalans) {
          return needToPay;
        }

        return this.user.availableBalance > needToPay ? 0
          : needToPay - this.user.availableBalance;
      }

      if (this.payFor === 'join' && this.payload.joinId) {
        let resultPrice = this.priceForJoin - (this.joinDiscount || 0);

        if (this.payload.summa) {
          resultPrice = +this.payload.summa;
        }

        if (debitBonuses) {
          resultPrice = resultPrice - bonuses > 0 ? resultPrice - bonuses : 0;
        }

        if (!this.payload.debitFromBalans) {
          return resultPrice;
        }

        return this.user.availableBalance > resultPrice ? 0
          : resultPrice - this.user.availableBalance;
      }

      return 0;
    },
    formValid() {
      if (!this.integrationId) {
        return false;
      }

      if (this.payFor === 'invoice' && this.payload.invoiceId) {
        const invoice = this.invoices.find((i) => i.id === this.payload.invoiceId);
        if (!invoice) {
          return false;
        }

        if (this.payload.debitBonuses
          && this.payload.bonusesSumma > this.payload.availableBonuses) {
          return false;
        }

        if (this.partialPaymentForInvoice && this.payload.summa) {
          return this.payload.summa <= invoice.needToPay && this.payload.summa > 0;
        }

        return true;
      }

      if (this.payFor === 'join' && this.payload.joinId) {
        const join = this.joins.find((j) => j.id === this.payload.joinId);
        if (!join) {
          return false;
        }

        const cl = this.classes.find((c) => c.id === join.classId);
        if (!cl || cl.payType === 'full') {
          return true;
        }

        let isSumValid = true;

        if (this.payload.summa) {
          isSumValid = this.payload.summa >= this.subPriceLimits.min
            && this.payload.summa <= this.subPriceLimits.max;
        }

        const subscriptionTypeIds = this.getSubscriptionTypesForClass(cl.id).map((s) => s.id);

        const isSubStartDate = this.isShowSubscriptionBeginDateSelect
          ? !!this.payload.subscriptionStartDate : true;

        if (this.payload.debitBonuses
          && this.payload.bonusesSumma > this.payload.availableBonuses) {
          return false;
        }

        return isSumValid
          && subscriptionTypeIds.includes(this.payload.subscriptionId) && isSubStartDate;
      }

      if (this.payFor === 'balans') {
        return this.payload.summa > 0;
      }

      return false;
    },
    agreementsAccepted() {
      const {
        dataProcessingAgreement: dpaChecked,
        userLicenseAgreement: ulaChecked,
      } = this.agreements;
      const {
        dataProcessingAgreement,
        userLicenseAgreement,
      } = this.onlinePaymentSettings;

      if (dataProcessingAgreement && dataProcessingAgreement.enabled
        && dataProcessingAgreement.link && !dpaChecked) {
        return false;
      }
      if (userLicenseAgreement && userLicenseAgreement.enabled
        && userLicenseAgreement.link && !ulaChecked) {
        return false;
      }

      return true;
    },
    nothingToPay() {
      return this.totalSum === '0.00';
    },
    createPaymentBtnText() {
      if (this.formValid && this.payload.debitFromBalans && this.nothingToPay) {
        return 'Списать средства с баланса';
      }

      if (this.formValid && this.payload.debitBonuses && this.nothingToPay) {
        return 'Списать бонусы с баланса';
      }

      if (this.formValid
        && (this.payload.debitFromBalans || this.payload.debitBonuses)
        && this.totalSum > 0
      ) {
        return 'Списать и перейти к оплате';
      }

      return 'Перейти к оплате';
    },
    onlinePaymentIntegrationsSelect() {
      let classId;
      let integrations;

      if (this.payFor === 'invoice' && this.payload.invoiceId) {
        const invoice = this.invoices.find((i) => i.id === this.payload.invoiceId);
        if (!invoice) {
          return null;
        }

        if (invoice.userSubscriptionId) {
          const sub = this.userSubscriptions.find((us) => us.id === invoice.userSubscriptionId);
          if (!sub) {
            return null;
          }

          classId = sub.mainClassId;
        }
        if (invoice.joinId) {
          const join = this.joins.find((j) => j.id === invoice.joinId);
          if (!join) {
            return null;
          }

          ({ classId } = join);
        }
      }

      if (this.payFor === 'join' && this.payload.joinId) {
        const join = this.joins.find((j) => j.id === this.payload.joinId);
        if (!join) {
          return null;
        }

        ({ classId } = join);
      }

      if (this.payFor !== 'balans' && !classId) {
        return null;
      }

      const sortFunc = (a, b) => (a.name > b.name ? 1 : -1);

      if (this.payFor !== 'balans') {
        const cl = this.classes.find((c) => c.id === classId);
        if (!cl) {
          return null;
        }

        integrations = this.onlinePaymentIntegrations
          .filter(({ filialIds }) => filialIds.includes(0) || filialIds.includes(cl.filialId))
          .sort(sortFunc);
      } else {
        integrations = this.onlinePaymentIntegrations
          .filter(({ filialIds }) => filialIds.includes(0)
            || filialIds.filter((value) => this.user.filials.includes(value)).length)
          .sort(sortFunc);
      }

      if (!integrations) {
        return null;
      }

      if (this.preassignedPayload.integrationId) {
        const int = integrations.find((i) => +this.preassignedPayload.integrationId === i.id);
        if (int) {
          return [int];
        }
      }

      return integrations;
    },
    ...mapGetters(['currency', 'user']),
  },
  methods: {
    changePaySum() {
      if (!this.showBonuses) {
        return;
      }
      const { entity, entityType } = this.getBpEntityData();
      if (!entityType || !entity) {
        return;
      }

      this.calculateBonuses(entity, entityType);
    },
    clearBpPayloadData() {
      this.$set(this.payload, 'debitBonuses', null);
      this.$set(this.payload, 'availableBonuses', null);
      this.$set(this.payload, 'bonusesSumma', null);
      this.showBonuses = false;
    },
    calculateBonuses(entity, entityType) {
      let price;
      let initPrice;
      let bonusesPaid = 0;

      // Если покупаем новое
      if (!this.payload.invoiceId) {
        if (entityType === 'sub') {
          price = (this.subPriceLimits.max)
            ? this.subPriceLimits.max
            // eslint-disable-next-line no-mixed-operators
            : this.priceForJoin - (this.priceForJoin * (this.userDiscount) / 100);
        }

        if (entityType === 'class') {
          price = this.priceForJoin;
        }

        initPrice = price;
      } else {
        const invoices = this.getInvoicesByPayload();
        price = invoices
          .reduce((acc, invoice) => acc + (invoice.needToPay || 0), 0);

        initPrice = invoices
          .reduce((acc, invoice) => acc + invoice.price, 0);

        bonusesPaid = invoices
          .reduce((acc, invoice) => acc + (invoice.payedBonuses || 0), 0);
      }

      let availableBonuses = getAvailableBonusesSum({
        entity,
        entityType,
        level: this.bpLevel,
        balance: this.user.bonusBalance,
        bonusesPaid,
        price,
        initPrice,
      });

      if (!this.payload.summa) {
        this.payload.availableBonuses = availableBonuses;
        this.payload.bonusesSumma = availableBonuses;
      } else {
        if (this.payload.summa <= availableBonuses) {
          availableBonuses = this.payload.summa;
        }

        this.payload.availableBonuses = availableBonuses;
        this.payload.bonusesSumma = availableBonuses;
      }
    },
    getInvoicesByPayload() {
      let invoices;

      const invoice = this.invoices
        .find((el) => el.id === this.payload.invoiceId);

      if (invoice.userSubscriptionId) {
        invoices = this.invoices
          .filter((el) => el.userSubscriptionId === invoice.userSubscriptionId);
      }

      if (invoice.joinId) {
        invoices = this.invoices.filter((el) => el.joinId === invoice.joinId);
      }

      return invoices;
    },
    getBpEntityData() {
      if (this.payload.subscriptionId) {
        const sub = this.subscriptionTypes.find((el) => el.id === this.payload.subscriptionId);
        return { entityType: 'sub', entity: sub };
      } if (this.payload.invoiceId) {
        const invoice = this.invoices.find((el) => el.id === this.payload.invoiceId);
        if (invoice.joinId) {
          const join = this.joins.find((el) => el.id === invoice.joinId);
          const cl = this.classes.find((el) => el.id === join.classId);
          return { entityType: 'class', entity: cl };
        }

        if (invoice.userSubscriptionId) {
          const userSub = this.userSubscriptions.find((el) => el.id === invoice.userSubscriptionId);
          const subType = this.subscriptionTypes.find((el) => el.id === userSub.subscriptionId);
          return { entityType: 'sub', entity: subType };
        }
      }

      return {};
    },
    showBonusesBlock() {
      if (!this.user) {
        return false;
      }

      const { bpLevel } = this.user;

      if (!(bpLevel && bpLevel.isActive)) {
        return false;
      }

      const { entityType, entity } = this.getBpEntityData();

      if (!entityType || !entity) {
        return false;
      }

      const isValid = isValidEntityForBPLevel({
        entityType,
        entity,
        level: this.bpLevel,
        operationType: 'points',
      });

      if (!isValid) {
        return false;
      }

      this.calculateBonuses(entity, entityType);

      return isValid;
    },
    updateRefreshKey() {
      // Ключ сделал для корректного обновления кнопки:
      // На Айфоне 6 при изменении некоторых параметров кнопка не становится активной -
      // проблема в перерисовке. key решает проблему.
      this.refreshKey += 1;
    },
    async createPayment() {
      this.loading = true;

      if (!this.formValid) {
        this.loading = false;
        return;
      }

      if (!this.agreementsAccepted) {
        this.setSnackErrorMessage('Необходимо принять все условия');
        this.loading = false;
        return;
      }

      const paymentData = {
        userId: this.user.id,
        integrationId: this.integrationId,
      };

      if (this.payFor === 'invoice') {
        paymentData.payload = {
          payFor: 'invoice',
          invoiceId: this.payload.invoiceId,
          debitFromBalans: !!this.payload.debitFromBalans,
          debitBonuses: !!this.payload.debitBonuses,
          summa: this.payload.summa ? +this.payload.summa : undefined,
        };

        if (this.payload.debitBonuses) {
          paymentData.payload.bonusesSumma = this.payload.bonusesSumma;
        }
      }

      if (this.payFor === 'balans') {
        paymentData.payload = {
          payFor: 'balans',
          summa: +this.payload.summa,
        };
      }

      if (this.payFor === 'join') {
        const join = this.joins.find((j) => j.id === this.payload.joinId);
        if (!join) {
          return;
        }
        const subTypes = this.getSubscriptionTypesForClass(join.classId);
        paymentData.payload = {
          summa: this.payload.summa ? +this.payload.summa : undefined,
          joinId: this.payload.joinId,
          subscriptionId: this.payload.subscriptionId,
          subscriptionStartDate: this.payload.subscriptionStartDate,
          debitFromBalans: !!this.payload.debitFromBalans,
          debitBonuses: !!this.payload.debitBonuses,
          payFor: subTypes.length ? 'subForExistingJoin' : 'existingJoin',
        };

        if (this.payload.debitBonuses) {
          paymentData.payload.bonusesSumma = this.payload.bonusesSumma;
        }

        const sub = subTypes.find((el) => el.id === this.payload.subscriptionId);
        if (sub && sub.type === 'dynamic') {
          const cl = this.classes.find((c) => c.id === join.classId);
          const filial = this.filials.find((el) => el.id === cl.filialId);
          const updatedSub = getSubscriptionForPayment(sub, filial);
          paymentData.payload.subscriptionVisitCount = updatedSub.visitCount;
        }
      }

      if (paymentData.payload.debitBonuses && !paymentData.payload.bonusesSumma) {
        delete paymentData.payload.debitBonuses;
        delete paymentData.payload.bonusesSumma;
      }

      try {
        const { data } = await Payment.create(paymentData, this.payLinkKey);

        if (data.result) {
          const result = await initPaymentProcess(data);
          if (result) {
            await this.handleSuccessPayment();
          }
          this.loading = false;
        } else if (data.error && data.error.message) {
          // Если списали с баланса и платить не нужно
          if (data.error.code === 'noNeedToPay') {
            await this.handleSuccessPayment();
          } else {
            this.setSnackInfoMessage(data.error.message);
          }
        } else {
          this.setSnackErrorMessage('Не удалось создать оплату. Пожалуйста, обновите страницу');
          this.loading = false;
        }
      } catch (e) {
        if (e.response && e.response.data
          && e.response.data.error && e.response.data.error.message) {
          this.setSnackErrorMessage(e.response.data.error.message);
        } else {
          this.setSnackErrorMessage('Оплата невозможна. Пожалуйста, обновите страницу');
        }
        this.loading = false;
      }
    },
    async handleSuccessPayment() {
      await this.$router.push({
        name: 'paymentResult',
        params: { payLinkKey: this.payLinkKey, result: 'success' },
      });
    },
    getClassName(id) {
      const cl = this.classes.find((c) => c.id === id);
      if (!cl) {
        return null;
      }
      return cl.name;
    },
    getSubscriptionTypesForClass(classId) {
      const cl = this.classes.find((c) => c.id === classId);
      if (!cl || cl.payType === 'full') {
        return [];
      }

      const { subscriptionIds } = cl.onlinePayment;

      const enabledSubs = this.subscriptionTypes.filter((sub) => {
        const byFilial = sub.filialIds.includes(cl.filialId) || sub.filialIds.includes(0);
        // Если мультиабонемент, то не сортируем по курсам
        if ((sub.courses && sub.courses.length) || (sub.classes && sub.classes.length)) {
          return byFilial && ((sub.courses.indexOf(-1) !== -1
            || sub.courses.indexOf(cl.courseId) !== -1
            || sub.classes.indexOf(cl.id) !== -1));
        }

        const { courseIds, classIds } = sub.onlinePayment;

        return byFilial && (courseIds.includes(-1) || courseIds.indexOf(cl.courseId) !== -1
          || classIds.indexOf(cl.id) !== -1);
      });
      const filial = this.filials.find((el) => el.id === cl.filialId);
      return enabledSubs
        .filter((sub) => subscriptionIds.includes(sub.id) || subscriptionIds.includes(-1))
        .map((sub) => {
          sub.displayName = getDisplayName(sub, filial);
          return sub;
        })
        .sort((a, b) => (a.displayName.toLowerCase() > b.displayName.toLowerCase() ? 1 : -1));
    },
    changePayFor() {
      this.clearBpPayloadData();
      this.payload = {};

      if (this.payFor === 'join') {
        this.payload.subscriptionStartDate = 'fromNow';
      }

      this.setDefaultIntegration();
      this.updateRefreshKey();
    },
    joinChange() {
      this.clearBpPayloadData();
      this.setDefaultIntegration();
      this.setDefaultSubscription();
      this.updateRefreshKey();
    },
    subsChange() {
      this.clearBpPayloadData();
      this.showBonuses = this.showBonusesBlock();
      this.updateRefreshKey();
    },
    invoiceChange() {
      this.setDefaultIntegration();
      this.clearBpPayloadData();
      this.showBonuses = this.showBonusesBlock();
      this.updateRefreshKey();
    },
    parseUrlParams() {
      const urlParams = this.$router.currentRoute.query;

      const needlePayloadKeys = ['integrationId', 'invoiceId', 'joinId', 'subscriptionId', 'payFor', 'summa', 'subscriptionStartDate'];
      needlePayloadKeys.forEach((key) => {
        const value = Number(urlParams[key]) || urlParams[key];
        if (value) {
          this.preassignedPayload[key] = value;
          this.payload[key] = value;
        }
      });

      this.payFor = urlParams.payFor || this.payFor;
    },
    validatePayload() {
      if (!['invoice', 'join', 'balans'].includes(this.payFor)) {
        this.payFor = 'invoice';
      }

      const {
        joinId,
        summa,
        invoiceId,
        integrationId,
        subscriptionId,
        subscriptionStartDate,
      } = this.payload;

      if (invoiceId && !this.selectInvoices.find(({ id }) => id === invoiceId)) {
        delete this.payload.invoiceId;
        delete this.preassignedPayload.invoiceId;
        delete this.preassignedPayload.payFor;
      }

      if (joinId && !this.selectJoins.find(({ id }) => id === joinId)) {
        delete this.payload.joinId;
        delete this.preassignedPayload.joinId;
        delete this.preassignedPayload.payFor;
      }

      if (subscriptionId && !this.selectSubscriptionTypes.find(({ id }) => id === subscriptionId)) {
        delete this.payload.subscriptionId;
        delete this.preassignedPayload.subscriptionId;
      }

      if (integrationId
        && this.onlinePaymentIntegrationsSelect
        && !this.onlinePaymentIntegrationsSelect.find(({ id }) => id === integrationId)) {
        this.integrationId = null;
        delete this.preassignedPayload.integrationId;
      }

      const { min, max } = this.subPriceLimits;
      if (summa && (summa < min || summa > max || (!max && !min))) {
        delete this.payload.summa;
        delete this.preassignedPayload.summa;
      }

      if (subscriptionStartDate && !this.payload.subscriptionId) {
        delete this.payload.subscriptionStartDate;
        delete this.preassignedPayload.subscriptionStartDate;
      }
    },
    async loadUserData() {
      this.isLoadingUserData = true;
      this.payLinkKey = this.$router.currentRoute.params.payLinkKey;

      try {
        const { data } = await UserData.fetch({ key: this.payLinkKey });

        this.joins = data.joins;
        this.classes = data.classes;
        this.filials = data.filials;
        this.invoices = data.invoices;
        this.uiSettings = data.uiSettings;
        this.totalDebt = data.invoicesStats.totalDebt;
        this.userSubscriptions = data.userSubscriptions;
        this.subscriptionTypes = data.subscriptionTypes;
        this.currentDebt = data.invoicesStats.currentDebt;
        this.onlinePaymentIntegrations = data.onlinePaymentIntegrations;

        const { onlinePaymentSettings } = data.company;
        if (onlinePaymentSettings) {
          this.onlinePaymentSettings = onlinePaymentSettings;
          this.agreements = {
            dataProcessingAgreement:
              onlinePaymentSettings.dataProcessingAgreement?.checkedByDefault,
            userLicenseAgreement:
              onlinePaymentSettings.userLicenseAgreement?.checkedByDefault,
          };
        }

        this.setUserData(data);

        this.parseUrlParams();
        this.validatePayload();

        this.isLoadingUserData = false;
      } catch (e) {
        if (e.response && e.response.status === 403) {
          await this.$router.push({ name: 'notCorrectPayLinkKey' });
        } else {
          this.setSnackErrorMessage('Произошла ошибка, попробуйте позже');
          throw e;
        }
      }
    },
    setDefaultSubscription() {
      if (this.selectSubscriptionTypes && this.selectSubscriptionTypes.length === 1) {
        this.payload.subscriptionId = this.selectSubscriptionTypes[0].id;
        this.subsChange();
      } else {
        delete this.payload.subscriptionId;
      }
    },
    setDefaultIntegration() {
      if (!this.onlinePaymentIntegrationsSelect) {
        return;
      }

      if (this.onlinePaymentIntegrationsSelect.length === 1) {
        this.integrationId = this.onlinePaymentIntegrationsSelect[0].id;
      }

      const { integrationId } = this.preassignedPayload;
      if (integrationId
        && this.onlinePaymentIntegrationsSelect.find(({ id }) => id === integrationId)) {
        this.integrationId = integrationId;
      }
    },
    ...mapMutations(['setSnackInfoMessage', 'setSnackErrorMessage', 'setUserData']),
  },
  async mounted() {
    await this.loadUserData();
    this.setDefaultIntegration();
    this.setDefaultSubscription();

    if (this.payload.invoiceId) {
      this.invoiceChange();
    }
  },
};
</script>

<style>
.logo {
  height: 120px;
}

.line-item {
  line-height: 1.5;
  padding-top: 5px;
  padding-bottom: 5px;
}

.agreements {
  .description {
    font-size: 14px;
  }
}

div[role="listbox"] {
  max-width: 500px;
}

.v-select .v-select__selections input {
  display: none !important;
}

.mc-bonuses-block {
  display: flex;
  flex-direction: row;

  .mc-bonuses-sum {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (max-width: 549px) {
    flex-direction: column;

    .mc-bonuses-sum {
      padding-left:  8px;
      padding-right: 8px;
    }
  }
}

</style>
